export const content = {
    domain: "Lendmarkfinancial",
    footer: "lendsmakfinancial.com",
    title1: "Online Loans Processed Quickly!",
  };
  